export default __webpack_public_path__ + "static/media/raleway-v18-latin-regular.d0033942.woff2";